import * as Block from "bs-platform/lib/es6/block.js";
import * as Curry from "bs-platform/lib/es6/curry.js";
import * as Printf from "bs-platform/lib/es6/printf.js";
import * as Pervasives from "bs-platform/lib/es6/pervasives.js";
import * as Js_mapperRt from "bs-platform/lib/es6/js_mapperRt.js";
var jsMapperConstantArray =
/* array */
[
/* tuple */
[-912009552, "generic"],
/* tuple */
[-643932289, "float64"],
/* tuple */
[-483486837, "int32"],
/* tuple */
[-438449797, "uint8"],
/* tuple */
[-57036806, "uint16"],
/* tuple */
[86585632, "buffer"],
/* tuple */
[159585247, "uint8_clamped"],
/* tuple */
[271008382, "float32"],
/* tuple */
[695277445, "int16"],
/* tuple */
[749056140, "int64"],
/* tuple */
[787930192, "int8"],
/* tuple */
[911682560, "uint32"],
/* tuple */
[951901561, "array"]];

function tToJs(param) {
  return Js_mapperRt.binarySearch(13, param, jsMapperConstantArray);
}

function tFromJs(param) {
  return Js_mapperRt.revSearch(13, jsMapperConstantArray, param);
}

function wrap(s) {
  var param = tFromJs(s);

  if (param !== undefined) {
    return param;
  } else {
    return Pervasives.failwith(Curry._1(Printf.sprintf(
    /* Format */
    [
    /* String */
    Block.__(2, [
    /* No_padding */
    0,
    /* String_literal */
    Block.__(11, [": dtype unsupported",
    /* End_of_format */
    0])]), "%s: dtype unsupported"]), s));
  }
}

function to_kind(dtype) {
  if (dtype >= 271008382) {
    if (dtype < 749056141) {
      if (dtype !== 695277445) {
        if (dtype >= 271008383) {
          if (dtype >= 749056140) {
            return (
              /* Int64 */
              7
            );
          }
        } else {
          return (
            /* Float32 */
            0
          );
        }
      } else {
        return (
          /* Int16_signed */
          4
        );
      }
    } else if (dtype !== 787930192) {
      if (dtype === 951901561) {
        return (
          /* Int64 */
          7
        );
      }
    } else {
      return (
        /* Int8_signed */
        2
      );
    }
  } else if (dtype >= -483486836) {
    if (dtype !== -438449797) {
      if (dtype === -57036806) {
        return (
          /* Int16_unsigned */
          5
        );
      }
    } else {
      return (
        /* Int8_unsigned */
        3
      );
    }
  } else if (dtype !== -643932289) {
    if (dtype >= -483486837) {
      return (
        /* Int32 */
        6
      );
    }
  } else {
    return (
      /* Float64 */
      1
    );
  }

  return Pervasives.failwith(Curry._1(Printf.sprintf(
  /* Format */
  [
  /* String_literal */
  Block.__(11, ["Unsupported dtype as a bigarray kind: ",
  /* Caml_string */
  Block.__(3, [
  /* No_padding */
  0,
  /* End_of_format */
  0])]), "Unsupported dtype as a bigarray kind: %S"]), tToJs(dtype)));
}

var unwrap = tToJs;
export { tToJs, tFromJs, wrap, unwrap, to_kind };
/* No side effect */